﻿import { ButtonView, View } from 'ckeditor5';

const linkIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
    <g>
        <path d="m10.895833333333336 19.135416666666668 -2.854166666666667 2.854166666666667a2.979166666666667 2.979166666666667 0 0 1 -4.104166666666667 0l-0.9270833333333334 -0.9270833333333334a2.885416666666667 2.885416666666667 0 0 1 -0.8541666666666666 -2.0833333333333335 2.854166666666667 2.854166666666667 0 0 1 0.8541666666666666 -2.0833333333333335l6.041666666666667 -6.052083333333333a2.9166666666666665 2.9166666666666665 0 0 1 4.104166666666667 0l0.9270833333333334 0.9375000000000001A1.0416666666666667 1.0416666666666667 0 1 0 15.5625 10.416666666666668l-0.9270833333333334 -0.9270833333333334a4.989583333333334 4.989583333333334 0 0 0 -7.052083333333333 0l-6.052083333333333 6.041666666666667a4.989583333333334 4.989583333333334 0 0 0 0 7.052083333333333l0.9270833333333334 0.9270833333333334a4.979166666666667 4.979166666666667 0 0 0 7.062500000000001 0l2.84375 -2.84375a1.0416666666666667 1.0416666666666667 0 0 0 0 -1.4791666666666667 1.0416666666666667 1.0416666666666667 0 0 0 -1.46875 -0.05208333333333334Z"></path>
        <path d="m23.468750000000004 2.4583333333333335 -0.9375000000000001 -0.9270833333333334a5 5 0 0 0 -7.052083333333333 0L12.5 4.5625a1.0416666666666667 1.0416666666666667 0 1 0 1.46875 1.46875l3.0312500000000004 -3.0208333333333335a2.9062500000000004 2.9062500000000004 0 0 1 4.104166666666667 0l0.9270833333333334 0.9375000000000001a2.854166666666667 2.854166666666667 0 0 1 0.8541666666666666 2.0833333333333335 2.885416666666667 2.885416666666667 0 0 1 -0.8541666666666666 2.0833333333333335l-6.041666666666667 6.041666666666667a2.885416666666667 2.885416666666667 0 0 1 -2.0833333333333335 0.8541666666666666 2.8645833333333335 2.8645833333333335 0 0 1 -2.0833333333333335 -0.8541666666666666A1.0416666666666667 1.0416666666666667 0 0 0 10.416666666666668 15.552083333333334a4.958333333333333 4.958333333333333 0 0 0 3.5312500000000004 1.46875 4.947916666666667 4.947916666666667 0 0 0 3.5208333333333335 -1.4583333333333333l6.052083333333333 -6.052083333333333a4.989583333333334 4.989583333333334 0 0 0 0 -7.052083333333333Z"></path>
    </g>
</svg>`;

const unlinkIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.463 19.264">
    <g transform="translate(-816.038 -848)">
        <g transform="translate(815.969 847.927)">
            <path d="M8.291,16.145,6.123,18.313a2.263,2.263,0,0,1-3.118,0l-.7-.7a2.192,2.192,0,0,1-.649-1.583A2.168,2.168,0,0,1,2.3,14.444l4.589-4.6a2.216,2.216,0,0,1,3.118,0l.7.712a.791.791,0,1,0,1.124-1.037l-.7-.7a3.79,3.79,0,0,0-5.357,0l-4.6,4.589a3.79,3.79,0,0,0,0,5.357l.7.7a3.782,3.782,0,0,0,5.365,0l2.16-2.16a.806.806,0,0,0-1.116-1.163Z" transform="translate(0 -2.052)"/>
            <path d="M19.892,1.883l-.712-.7a3.8,3.8,0,0,0-5.357,0l-2.263,2.3A.791.791,0,1,0,12.676,4.6l2.3-2.295a2.208,2.208,0,0,1,3.118,0l.7.712A2.168,2.168,0,0,1,19.449,4.6,2.192,2.192,0,0,1,18.8,6.179l-4.589,4.589a2.254,2.254,0,0,1-3.165,0,.791.791,0,0,0-1.068,1.06,3.782,3.782,0,0,0,5.357.008l4.6-4.6a3.79,3.79,0,0,0,0-5.357Z" transform="translate(-2.509 0)"/>
        </g>
        <path d="M12.99,7.368l-.432-.432a.608.608,0,0,0-.858,0L10.057,8.548a.152.152,0,0,1-.219,0L8.226,6.936a.608.608,0,0,0-.858,0l-.432.432a.608.608,0,0,0,0,.858L8.548,9.838a.152.152,0,0,1,0,.219L6.936,11.669a.608.608,0,0,0,0,.858l.432.432a.608.608,0,0,0,.858,0l1.612-1.612a.152.152,0,0,1,.219,0l1.612,1.643a.608.608,0,0,0,.858,0l.432-.432a.608.608,0,0,0,0-.858l-1.612-1.643a.152.152,0,0,1,0-.219L12.99,8.226A.608.608,0,0,0,12.99,7.368Z" transform="translate(819.54 854.098)"/>
    </g>
</svg>`;

export { linkIcon, unlinkIcon };

export default class LinkActionsView extends View {

    constructor(locale) {
        super(locale);

        const t = locale.t;

        var unlinkButton = this._createButton(t('Unlink'), unlinkIcon, 'unlink');
        var editButton = this._createButton(t('Edit link'), linkIcon, 'edit');

        this.setTemplate({
            tag: 'div',

            attributes: {
                class: [
                    'ck',
                    'ck-link-actions',
                    'ck-responsive-form'
                ],

                // https://github.com/ckeditor/ckeditor5-link/issues/90
                tabindex: '-1'
            },

            children: [
                editButton,
                unlinkButton
            ]
        });
    }

    _createButton(label, icon, eventName) {
        const button = new ButtonView(this.locale);

        button.set({
            label,
            icon,
            tooltip: true,
            class: eventName === 'unlink' ? 'ck-button__unlink' : ''
        });

        button.delegate('execute').to(this, eventName);

        return button;
    }
};